import { cardSchema, type Card } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postArchive = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/cards/${id}/archive`, { method: 'POST' });

export const archiveCard = async (id: string): Promise<Card> =>
  cardSchema.parse(await postArchive(id));
